export default __webpack_public_path__ + "static/media/our-service-information-technology-content.478925f6.jpg";